import React from 'react';
import * as Ant from 'antd';
import styled from 'styled-components';
import {zip3} from 'rev.sdk.js/Constants/taiwan';

export default function RjsfAddressField(props) {
  const {
    formData,
    schema,
    uiSchema = {},
    errorSchema,
    required,
    ...extra
  } = props;
  const title = schema?.title || '地址';
  const extraCss = uiSchema['rev:css'] || '';

  const allCities = [...Array.from(new Set(zip3.map((it) => it.city)))]; // '海外'
  const allDistricts = zip3.filter((it) => it.city === formData?.city);

  const disabled = schema.readOnly || schema.readonly;

  return (
    <Wrapper extraCss={extraCss} id={extra.id}>
      <label className={required ? 'required' : ''}>{title}</label>
      <div style={{flex: 1}}>
        <div
          style={{
            display: 'flex',
            gap: 8,
            flexWrap: 'wrap',
            alignItems: 'center',
          }}>
          <div>
            <Ant.Select
              placeholder="縣市"
              style={{width: 100}}
              value={formData?.city}
              disabled={disabled || schema?.properties?.city?.readOnly}
              status={errorSchema.city?.__errors ? 'error' : null}
              onChange={(value) => {
                props.onChange({
                  ...formData,
                  city: value,
                  district: undefined,
                  zip: undefined,
                });
              }}>
              {allCities.map((it) => {
                return (
                  <Ant.Select.Option value={it} key={it}>
                    {it}
                  </Ant.Select.Option>
                );
              })}
            </Ant.Select>
            <div className="ant-form-item-explain-error">
              {errorSchema.city?.__errors}
            </div>
          </div>

          <div>
            <Ant.Select
              placeholder="鄉鎮市區"
              style={{width: 100}}
              disabled={disabled || schema?.properties?.district?.readOnly}
              status={errorSchema.district?.__errors ? 'error' : null}
              value={formData?.district}
              onChange={(value) => {
                const zip = allDistricts.find((it) => it.district === value)
                  ?.zip;

                props.onChange({...formData, district: value, zip});
              }}>
              {allDistricts.map((it) => {
                return (
                  <Ant.Select.Option value={it.district} key={it.district}>
                    {it.district}
                  </Ant.Select.Option>
                );
              })}
            </Ant.Select>
            <div className="ant-form-item-explain-error">
              {errorSchema.district?.__errors}
            </div>
          </div>
          {formData?.zip && (
            <div style={{color: '#ccc'}}>郵遞區號：{formData?.zip}</div>
          )}
        </div>
        <div>
          <Ant.Input
            style={{width: '100%', marginTop: 8}}
            className="rev-input"
            placeholder="詳細地址"
            disabled={disabled || schema?.properties?.detail?.readOnly}
            status={errorSchema.detail?.__errors ? 'error' : null}
            value={formData?.detail}
            onChange={(e) => {
              props.onChange({...formData, detail: e.target.value});
            }}
          />
          <div className="ant-form-item-explain-error">
            {errorSchema.detail?.__errors}
          </div>
        </div>
        {/* <div className="help">* 若為海外地址，詳細資訊內請包含郵遞區號</div> */}
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & > label {
    width: 80px;
    &.required::before {
      content: '*';
      color: #ff4d4f;
      margin-right: 4px;
    }
  }

  & .help {
    color: #888;
  }

  ${(props) => props.extraCss}
`;
